export default __webpack_public_path__ + "static/opinion-3-e6a2b3e8e8305694caedd0f2916a85f9.jpg";